import React, { useState, useEffect } from "react";
import { Row, Col, Image } from "react-bootstrap";
import Axios from "axios";
import { useDispatch } from "react-redux";

//STYLES
import * as AlbumViewerStyles from "../styles/albumViewer";

//COMPONENTS
import VideoTileSlot from "./videoTileSlot";
import VideoViewer from "./videoViewer";
import VideoListSlot from "./videoListSlot";

function VideoAlbumViewer(props) {
    const dispatch = useDispatch();

    const [view, setView] = useState("t");

    const [videos, setVideos] = useState([]);

    const videoViewerDefaults = {
        open: false,
        videoURL: ""
    };

    const [videoViewer, setVideoViewer] = useState(videoViewerDefaults);

    function handleVideoViewerClose() {
        setVideoViewer(videoViewerDefaults);
    }

    useEffect(() => {
        const data = { album: props.name };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_FREND/getVideoAlbumVideos", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    setVideos(data.videos);
                }
            })
            .catch((err) => console.log(err));
    }, [props.name]);

    function handleThumbnailOnClick(videoURL) {
        setVideoViewer({ videoURL: videoURL, open: true });
    }

    function handleSetView(view) {
        setView(view);
    }

    const tiles = (
        <Row>
            {videos.map((video, index) => {
                return (
                    <Col sm={3} key={index}>
                        <VideoTileSlot
                            album={props.name}
                            title={video.title}
                            thumbnail={video.thumbnailURL}
                            videoURL={video.videoURL}
                            onClick={handleThumbnailOnClick}
                            id={index}
                        />
                    </Col>
                );
            })}
        </Row>
    );

    const list = (
        <div>
            {videos.map((video, index) => {
                return (
                    <div key={index}>
                        <VideoListSlot
                            album={props.name}
                            title={video.title}
                            thumbnail={video.thumbnailURL}
                            videoURL={video.videoURL}
                            onClick={handleThumbnailOnClick}
                            id={index}
                        />
                        <br />
                    </div>
                );
            })}
        </div>
    );

    return (
        <div style={AlbumViewerStyles.body}>
            <Row>
                <Col sm={1}></Col>
                <Col>
                    <Row>
                        <Col>
                            <div style={AlbumViewerStyles.backButton} onClick={props.goBack}>
                                Back
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col style={AlbumViewerStyles.rightColumn}>
                    <div
                        style={
                            view == "t"
                                ? { ...AlbumViewerStyles.viewAllButton, backgroundColor: "blue", color: "white" }
                                : AlbumViewerStyles.viewAllButton
                        }
                        onClick={handleSetView.bind(this, "t")}
                    >
                        Tilies
                    </div>
                    <div
                        style={
                            view == "l"
                                ? { ...AlbumViewerStyles.viewOneButton, backgroundColor: "blue", color: "white" }
                                : AlbumViewerStyles.viewOneButton
                        }
                        onClick={handleSetView.bind(this, "l")}
                    >
                        List
                    </div>
                </Col>
                <Col sm={1}></Col>
            </Row>
            <br />
            <Row>
                <Col sm={1} style={AlbumViewerStyles.leftColumn}></Col>
                <Col>
                    {view == "t" && tiles}
                    {view == "l" && list}
                </Col>
                <Col sm={1}></Col>
            </Row>
            <VideoViewer open={videoViewer.open} handleClose={handleVideoViewerClose} videoURL={videoViewer.videoURL} />
        </div>
    );
}

export default VideoAlbumViewer;
